import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { NavController } from '@ionic/angular';

@Component({
  selector: 'app-setup-footer',
  templateUrl: './setup-footer.component.html',
  styleUrls: ['./setup-footer.component.scss'],
})
export class SetupFooterComponent implements OnInit, OnChanges {

  @Input() saveId: string;

  @Input() prevPath: string;
  @Input() prevLbl: string;
  @Input() nextPath: string;
  @Input() nextLbl: string;

  @Input() saveLbl = 'Save';
  @Input() cancelLbl = 'Cancel';
  @Input() deleteLbl = 'Delete';

  @Input() showDelete = true;
  @Input() showSave = true;
  @Input() showCancel = true;

  @Output() deleteClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() cancelClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() saveClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private navCtrl: NavController) { }

  ngOnInit() {
    this.updButtons();
  }
  ngOnChanges() {
    this.updButtons();
  }
  updButtons() {
    if (this.deleteClicked.observers.length === 0) {
      this.showDelete = false;
    }
    if (this.saveClicked.observers.length === 0) {
      this.showSave = false;
    }
    if (this.cancelClicked.observers.length === 0) {
      this.showCancel = false;
    }
  }

  gotoPrevious() {
    this.navCtrl.navigateForward(this.prevPath);
  }

  gotoNext() {
    this.navCtrl.navigateForward(this.nextPath);
  }

  save() {
    this.saveClicked.emit(true);
  }

  delete() {
    this.deleteClicked.emit(true);
  }

  cancel() {
    this.cancelClicked.emit(true);
  }

  isNullOrEmpty(str: string) {
    return String.isNullOrWhiteSpace(str);
  }
}
